import "../scss/base_rem.scss";
import "../scss/common_rem.scss";

import "./header";
import $ from "./jq";

(function(){
    let articlesLen = document.querySelectorAll(".j-news-item").length;
    if(articlesLen < 10){
        $(".j-next-page-btn").addClass("hide")
    }
    $(".j-next-page-btn").on("click",function(){
        let curPage = $.getHrefParam("page") ;
        let nextPage = curPage;
        try{
            nextPage = parseInt(curPage) + 1;
            if(isNaN(nextPage)){
                nextPage = 2;
            }
        }catch(e){
            nextPage = 2;
        }
        let href = location.href;
        
        let newHref = "";
        if("" == curPage){
            if(/\?(?=(\w*\_*\-*)+\=)/.test(href)){
                newHref = href + `&page=${nextPage}`;
            }else{
                newHref = href + `?page=${nextPage}`;
            }
        }else{
            newHref = href.replace(`page=${curPage}`,`page=${nextPage}`);
        }
      
        location.href = newHref;
    })
})()
